var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"overflow-hidden rounded-0",attrs:{"flat":""}},[_c('navigation-content',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('navigation-menu'),_c('v-main',[_c('router-view')],1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }